import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3'
import CONSTANTS from '@/constants'
import TextField from '@/components/TextField'
import { Button, Box, Typography } from '@mui/material'
import useAccount from '@/concepts/Account/hooks/useAccount'

const ForgotPassword = () => {
  const { requestPasswordReset } = useAccount()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null)

  const onVerify = useCallback((token: string) => {
    setRecaptchaToken(token)
  }, [])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    requestPasswordReset(
      { email, recaptchaToken },
      () => {
        navigate('/login')
      },
      () => {
        setLoading(false)
      }
    )
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={CONSTANTS.RECAPTCHA_V3_SITE_KEY}>
      <Box
        sx={{
          maxWidth: 400,
          mx: 'auto',
          mt: 8,
          p: 4,
          boxShadow: 2,
          borderRadius: 2,
          backgroundColor: 'background.paper'
        }}
      >
        <Typography variant="h5" align="center" gutterBottom>
          Forgot Password
        </Typography>
        <Typography variant="body2" align="center" sx={{ mb: 2 }}>
          Enter your email address and we will send you instructions to reset
          your password.
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            value={email}
            onChange={setEmail}
            type="text"
            fullWidth
            sx={{ mb: 2 }}
          />
          <GoogleReCaptcha onVerify={onVerify} refreshReCaptcha />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading || !email}
          >
            {loading ? 'Sending...' : 'Send Reset Instructions'}
          </Button>
        </form>
      </Box>
    </GoogleReCaptchaProvider>
  )
}

export default ForgotPassword
